export default {
      id: "information-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#information",
      toString: function () {
        return this.url;
      }
    }